import { z } from 'zod';

export const userApiKeyScopeSchema = z.enum(['VIEWER', 'REVIEWER', 'JOB_ARCHITECT']);

export type UserApiKeyScope = z.infer<typeof userApiKeyScopeSchema>;

const userApiKeyUserSchema = z.object({
    email: z.string().nullish(),
    firstName: z.string(),
    id: z.uuid(),
    lastName: z.string(),
});

export const userApiKeySchema = z.object({
    createdAt: z.iso.datetime(),
    description: z.string().nullable(),
    expiresAt: z.iso.datetime(),
    id: z.uuid(),
    isActive: z.boolean().optional(),
    lastUsedAt: z.iso.datetime().nullish(),
    name: z.string(),
    scope: userApiKeyScopeSchema,
    user: userApiKeyUserSchema.optional(),
});

export type UserApiKey = z.infer<typeof userApiKeySchema>;

export const userApiKeyCreateResponseSchema = userApiKeySchema.extend({
    apiKey: z.string().min(1),
});

export type UserApiKeyCreateResponse = z.infer<typeof userApiKeyCreateResponseSchema>;

export const userApiKeysSchema = userApiKeySchema.array();

export type UserApiKeyCreate = {
    readonly description: string | null;
    readonly expiresAt: string;
    readonly name: string;
    readonly scope: UserApiKeyScope;
};
